module.exports = __webpack_public_path__ + "static/img/bg_button_normal.png";